import {NgModule} from '@angular/core';

import {QuoteRateLimiterComponent} from './quote-rate-limiter.component';
import {DevExtremeModule} from "../devextreme.module";
import {CommonModule} from "@angular/common";
import {QuoteRateLimiterService} from "./quote-rate-limiter.service";

@NgModule({
    imports: [DevExtremeModule, CommonModule],
    exports: [QuoteRateLimiterComponent],
    declarations: [QuoteRateLimiterComponent],
    providers: [QuoteRateLimiterService],
})
export class QuoteRateLimiterModule {
}
